export { default } from "./ResponseTimeTimeProgress.component";
